import {h, Fragment} from "preact"
import { useSelectedFiltersCount, useFacets, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import { isMobile } from "../helpers"

import ToolbarFacets from "./ToolbarFacets"
import Sidebar from "./Sidebar"
import Select from "./elements/Select"
import CustomDropdown from "./CustomDropdown"

export default function Toolbar() {
    const { facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()
    const options = sortOptions.map(o => ({ value: o.id, text: o.value.name }))

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <div class="ns-toolbar w-full flex justify-between items-center px-8 py-12 mx-auto max-w-screen-xl">
            {isMobile ? (
                <>
                    <Select
                        className="ns-select-sort button--pill"
                        label="Sort by"
                        value={activeSort}
                        options={options}
                        onChange={handleSortChange}
                    />
                    <Sidebar />
                </>
            ) : (
                <>
                    <ToolbarFacets />

                    <CustomDropdown
                        className="ns-select-sort button--pill"
                        label="sort"
                        value={activeSort}
                        options={options}
                        onChange={handleSortChange}
                    />
                </>
            )}
        </div>
    )
}
